import { Trans } from 'react-i18next';
import * as yup from 'yup';

import { MAX_FIRST_NAME_LENGTH, MAX_LAST_NAME_LENGTH, MIN_LENGTH } from '@hero/constants';

const profileSchema = yup.object().shape({
  firstName: yup
    .string()
    .min(MIN_LENGTH)
    .max(MAX_FIRST_NAME_LENGTH)
    .required(<Trans i18nKey="errors.noFirstName" />),
  lastName: yup
    .string()
    .min(MIN_LENGTH)
    .max(MAX_LAST_NAME_LENGTH)
    .required(<Trans i18nKey="errors.noLastName" />),
  phoneNumber: yup
    .string()
    .min(11, <Trans i18nKey="errors.phoneLength" />)
    .required(<Trans i18nKey="errors.noPhoneNumber" />)
});

export { profileSchema };
